import React from "react"

import { colors } from "@/styles/colors"

import PortletWithSplitContent from "@/components/PortletWithSplitContent"
import { Typography } from "@material-ui/core"
import ColorUtil from "@/utils/ColorUtil"
import LetalkLogo from "@/components/SVGComponents/LetalkLogo"
import useCustomStyles from "@/styles/custom"

const CheckEmailAfterUserCreatedPage: React.FC = () => {
	const customClasses = useCustomStyles()
	return (
		<PortletWithSplitContent
			title={{
				value: "Confirmação de email",
				logo: <LetalkLogo
					className={customClasses.logo}/>,
				...ColorUtil.getBackgroundAndContrastColor(colors.green[500])
			}}
			body={{
				...ColorUtil.getBackgroundAndContrastColor(colors.gray[0])
			}}
		>
			<Typography
				align="center"
				variant="subtitle1"
			>
				Clique no link enviado para o seu email e acesse a Letalk!
			</Typography>
		</PortletWithSplitContent>
	)
}

export default CheckEmailAfterUserCreatedPage
